import React from "react";
import ConversionPage from "@/components/ConversionPage";

export default function FoundationsAdultsPage() {
  return (
    <ConversionPage
      accentColor="blue"
      badge="Foundations  |  Adults  |  All Experience Levels"
      headline={<>YOU DON'T NEED<br />MORE TIME.<br /><span className="text-blue-400">YOU NEED A BETTER PLAN.</span></>}
      subheadline="Whether you played a sport 10 years ago or you've never touched a barbell, Foundations meets you where you are. Build real strength, move without pain, and feel the difference in weeks — not months."
      heroImage="https://images.unsplash.com/photo-1592702355956-c3cd5c5ed30c?auto=format&fit=crop&w=1920&q=80"
      painPoints={[
        "You've tried gym routines from the internet but never stuck with one longer than 3 weeks.",
        "You're not sure if you're doing exercises correctly and you don't want to get hurt.",
        "You know you should be training but you have no idea where to start — or restart.",
      ]}
      featureTitle="What's Inside Foundations"
      features={[
        { title: "2 Sessions Per Week", desc: "No daily grind. Two focused sessions that fit your schedule and still deliver real results." },
        { title: "Structured Programs", desc: "No guesswork. Every week is planned out — just show up and follow the program." },
        { title: "Progressive Overload", desc: "The system tracks your weights and tells you when to go up. You'll get stronger without thinking about it." },
        { title: "Mobility & Recovery", desc: "Every session includes warm-up and cool-down protocols to keep your joints happy." },
        { title: "Exercise Video Library", desc: "Watch proper form for every movement. No more wondering if you're doing it right." },
        { title: "Progress Tracking", desc: "See your lifts, your consistency, and your growth over time. Data doesn't lie." },
      ]}
      testimonial={{
        quote: "The best program is the one you actually follow. Foundations is designed to be that program.",
        name: "Paladin Coaching Staff",
        detail: "Built on the same science used with competitive athletes",
      }}
      price="$20"
      priceInterval="week"
      priceCta="Start Foundations"
      priceTier="foundations"
      faqs={[
        { q: "I haven't worked out in years. Is this for me?", a: "Yes. Foundations starts wherever you are. The program adapts to your level and progresses you safely. No ego lifting, just smart training." },
        { q: "Do I need a gym membership?", a: "Yes, you'll need access to basic equipment: a barbell, dumbbells, and a squat rack. Any commercial gym will have what you need." },
        { q: "How is this different from a free program?", a: "Free programs don't track your progress, adjust your weights, or hold you accountable. Foundations is a system — it remembers where you left off and pushes you forward." },
        { q: "Can I cancel anytime?", a: "Yes. No contracts, no commitments. Cancel from your dashboard whenever you want." },
      ]}
      backPath="/foundations"
    />
  );
}
